import {
  Text,
  Button,
  IconChevronRight,
  IndigoIndigo60,
  Primary13SemiBold,
  Center
} from '@sequencehq/core-components'

type Props = {
  label: string
  isToggled: boolean
  onToggle: (newState: boolean) => void
  'data-testid'?: string
}

export const CollapsibleToggle = ({
  label,
  isToggled,
  onToggle,
  'data-testid': dataTestId
}: Props) => {
  return (
    <Button
      variant="unstyled"
      onClick={() => onToggle(!isToggled)}
      data-testid={dataTestId}
      style={{ padding: '0px', gap: '4px' }}
      color={IndigoIndigo60}
    >
      <Center
        boxSize="16px"
        transform={isToggled ? 'rotate(90deg)' : 'rotate(0deg)'}
        transition="transform 250ms"
      >
        <IconChevronRight color="inherit" />
      </Center>

      <Text {...Primary13SemiBold} color="inherit">
        {label}
      </Text>
    </Button>
  )
}
